import useProductOrder from "hooks/order/useProductOrder"

import ProductOrderWrapper from "components/presenters/commerce/order/productOrder/ProductOrderWrapper"
import OrderInfoSection from "components/presenters/commerce/order/productOrder/OrderInfoSection"
import AddPostAddess from "components/presenters/commerce/order/productOrder/AddPostAddress/AddPostAddress"
import CurrShipping from "components/presenters/commerce/order/productOrder/CurrShipping"
import OrderProductInfoSection from "components/presenters/commerce/order/productOrder/OrderProductInfoSection"
import OrderItem from "components/presenters/commerce/order/OrderItem"
import PriceDetailInfo from "components/presenters/commerce/order/productOrder/PriceDetailInfo"
import TotalPriceInfo from "components/presenters/commerce/order/productOrder/TotalPriceInfo"
import PaymentTermsAgree from "components/presenters/commerce/order/productOrder/PaymentTermsAgree"
import PaymentButton from "components/presenters/commerce/order/productOrder/PaymentButton"

import SplitterBar from "components/presenters/common/SplitterBar"

export default function ProductOrder({ selectedOptions, purchaseType, productTitle, productImg }) {
  const {
    currShipping,
    shippingDetail,
    shippingPrice,
    subTotalPrice,
    totalPrice,
    serviceAgreement,
    isValid,
    handleChangeShippingDetail,
    handleChangeShippingDetailByEtc,
    openShippingAddressForm,
    openShippingChangeWindow,
    openAgreementAlertModal,
    handleChangePaymentTermsAgree,
    handlePayment,
  } = useProductOrder({
    selectedOptions,
    purchaseType,
  })

  return (
    <>
      <ProductOrderWrapper>
        <OrderInfoSection>
          {currShipping === null ? (
            <AddPostAddess openShippingAddressForm={openShippingAddressForm} />
          ) : (
            <CurrShipping
              address1={currShipping.address1}
              address2={currShipping.address2}
              recipient={currShipping.recipient}
              phone={currShipping.phone}
              shippingDetail={shippingDetail}
              shippingAction={currShipping.shipping_action}
              onChangeShippingDetail={handleChangeShippingDetail}
              onChangeShippingDetailByEtc={handleChangeShippingDetailByEtc}
              openShippingChangeWindow={openShippingChangeWindow}
            />
          )}
          <SplitterBar color="#EFEFEF" />
          <OrderProductInfoSection title="주문상품">
            {Array.isArray(selectedOptions) &&
              selectedOptions.map((option) => (
                <OrderItem
                  key={`order-product-option-no-${option.no}`}
                  isChallenge={option.isChallenge}
                  title={productTitle}
                  bannerImg={productImg}
                  optionName={option.name}
                  unitPrice={option.price}
                  challengeUnitPrice={option.challengePrice}
                  quantity={option.count}
                />
              ))}
          </OrderProductInfoSection>
          <SplitterBar color="#EFEFEF" />
          <PriceDetailInfo subTotalPrice={subTotalPrice} shippingPrice={shippingPrice} />
          <SplitterBar color="#EFEFEF" />
          <TotalPriceInfo totalPrice={totalPrice} />
          <SplitterBar color="#EFEFEF" />
          <PaymentTermsAgree onCheck={handleChangePaymentTermsAgree} isChecked={serviceAgreement} />
        </OrderInfoSection>
      </ProductOrderWrapper>
      <PaymentButton
        existCurrShipping={!!currShipping}
        totalPrice={totalPrice}
        isValid={isValid}
        onAlertAgreement={openAgreementAlertModal}
        onPayment={handlePayment}
      />
    </>
  )
}
